import { isTMA } from "@telegram-apps/sdk";

export enum MiniAppPlatform {
    Telegram = "telegram",
    Max = "max",
    Unknown = "unknown",
}

const MAX_BRIDGE_LOCAL_SRC = "/vendor/max-web-app.js";

type MaxWebAppLike = {
    ready?: unknown;
    close?: unknown;
    initData?: unknown;
    openMaxLink?: unknown;
    shareMaxContent?: unknown;
    version?: unknown;
};

const getTelegramWebApp = (): unknown => (window as Window & { Telegram?: { WebApp?: unknown } }).Telegram?.WebApp;

const getMaxWebApp = (): MaxWebAppLike | undefined => (window as Window & { WebApp?: MaxWebAppLike }).WebApp;

export const getMaxInitData = (): string | undefined => {
    const s = getMaxWebApp()?.initData;
    return typeof s === "string" && s.length > 0 ? s : undefined;
};

export const detectMiniAppPlatform = (): MiniAppPlatform => {
    if (typeof window === "undefined") return MiniAppPlatform.Unknown;

    if (getTelegramWebApp()) return MiniAppPlatform.Telegram;

    const wa = getMaxWebApp();
    const maxHasMethods = Boolean(wa && typeof wa.ready === "function" && typeof wa.close === "function");
    const maxHasApiSignature =
        typeof wa?.openMaxLink === "function"
        || typeof wa?.shareMaxContent === "function"
        || (typeof wa?.version === "string" && wa.version.length > 0);

    // Главный сигнал "реального MAX": initData непустой (нужен для валидации на бэке).
    if (maxHasMethods && maxHasApiSignature && getMaxInitData()) return MiniAppPlatform.Max;

    if (isTMA()) return MiniAppPlatform.Telegram;

    return MiniAppPlatform.Unknown;
};

export const getMiniAppPlatformTitle = (platform: MiniAppPlatform): string => {
    switch (platform) {
        case MiniAppPlatform.Telegram:
            return "Телеграм";
        case MiniAppPlatform.Max:
            return "Макс";
        default:
            return "Неизвестно";
    }
};

const getExistingMaxBridgeScript = (): HTMLScriptElement | null => document.querySelector<HTMLScriptElement>('script[data-max-bridge="1"]');

export const ensureLocalMaxBridgeLoaded = async (): Promise<void> => {
    if (typeof window === "undefined") return;

    if (getTelegramWebApp() || isTMA()) return;

    const wa = getMaxWebApp();
    if (wa && typeof wa.ready === "function" && typeof wa.close === "function") return;

    const existing = getExistingMaxBridgeScript();
    if (existing) return;

    await new Promise<void>((resolve) => {
        const script = document.createElement("script");
        script.src = MAX_BRIDGE_LOCAL_SRC;
        script.async = true;
        script.dataset.maxBridge = "1";
        script.onload = () => resolve();
        script.onerror = () => resolve();
        document.head.appendChild(script);
    });
};

